import React, { FC } from 'react';
import { getFullDate } from '../../../../../utils/helpers/date-helper';
import { ChangeConnectionStatusButton } from '../../../attendee-connectin-control/connection-control-button';

interface IProps {
  name: string;
  email: string;
  arrival: string;
  departure: string;
  hideAttendeeConnectionButton: boolean;
  disableAttendeeConnectionButton: boolean;
  renderAttendeeConnectionButton: boolean;
  onConnectionAttendeeAction: () => void;
  shouldRenderAttendeeStatusLabel: boolean;
  attendeeStatusLabel?: string;
  attendeeConnectionButtonLabel: string;
}

const AttendeesTableRow: FC<IProps> = ({
  name,
  email,
  arrival,
  departure,
  disableAttendeeConnectionButton,
  hideAttendeeConnectionButton,
  renderAttendeeConnectionButton,
  onConnectionAttendeeAction,
  shouldRenderAttendeeStatusLabel,
  attendeeStatusLabel,
  attendeeConnectionButtonLabel
}) => {
  return (
    <div className='table-row table-body-row attende-column-width'>
      <div className='table-row-data'>{name}</div>
      <div className='table-row-data'>{email}</div>
      <div className='table-row-data'>{getFullDate(arrival)}</div>
      <div className='table-row-data'>{departure}</div>
      {shouldRenderAttendeeStatusLabel && attendeeStatusLabel && (
        <span className='attendee-status-label'>{attendeeStatusLabel}</span>
      )}
      <ChangeConnectionStatusButton
        disabled={disableAttendeeConnectionButton}
        hidden={hideAttendeeConnectionButton}
        shouldRender={renderAttendeeConnectionButton && !shouldRenderAttendeeStatusLabel}
        onClick={onConnectionAttendeeAction}
        label={attendeeConnectionButtonLabel}
      />
    </div>
  );
};

export default AttendeesTableRow;